import React from 'react';
import { Navigate } from 'react-router-dom';
import QuestionsAndAnswers from './pages/QuestionsAndAnswerss';
import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';
import Faq from '../Faq';
import { QUESTIONS_ROUTES } from './data';
import QuestionAndAnswersSettings from './pages/QuestionAndAnswersSettings';

export default [
  {
    path: QUESTIONS_ROUTES.Q_AND_A,
    element: QuestionsAndAnswers,
  },
  {
    path: QUESTIONS_ROUTES.FAQ,
    element: Faq,
  },
  {
    path: QUESTIONS_ROUTES.Q_AND_A_SETTINGS,
    element: QuestionAndAnswersSettings,
  },
  {
    index: true,
    element: <Navigate to={QUESTIONS_ROUTES.Q_AND_A} replace />,
  },
] as Array<EnhancedRouteProps>;
